import { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      height: 44,
      padding: '0 8px 0 16px',
      borderRadius: 22,
      border: `1px solid ${color.$10}`,
      backgroundColor: color.$7,
    },
    'root--no-counter': {
      padding: '0 24px',
    },
    'root--focus': {
      borderColor: color.$1,
    },
    'root--error': {
      borderColor: color.$17,
    },
    input: {
      display: 'block',
      flex: '1 1 auto',
      width: '100%',
      outline: 'none',
      margin: '0 8px 0 0',
      border: 'none',
      '&:disabled': {
        backgroundColor: color.$7,
      },
    },
    'input--no-counter': {
      margin: 0,
    },
    wordCounter: {
      display: 'block',
      fontSize: 11,
      lineHeight: 1,
      color: color.$10,
    },
    'wordCounter--error': {
      color: color.$17,
    },
  }),
  {
    name: 'TextFieldCardCounter',
  },
);

function TextFieldCardCounter({
  className,
  maxCount,
  placeholder,
  value,
  onChange,
  status,
  inputRef,
  onFocus,
  id,
  isDisable,
  type,
  name,
  filterName,
  onBlur,
  unit,
}) {
  const classes = useStyles();
  const [isFocus, setIsFocus] = useState(false);
  function handleChange(e) {
    const v = e.target.value;
    onChange(v);
  }

  return (
    <div
      className={classnames(classes.root, className, {
        [classes['root--focus']]: isFocus,
        [classes['root--error']]:
          (maxCount > 0 && value.replace(filterName, '').length > maxCount) ||
          status === 'error',
        [classes['root--no-counter']]: maxCount === 0,
      })}
    >
      <input
        name={name || ''}
        id={id}
        ref={inputRef}
        className={classnames(classes.input, {
          [classes['input--no-counter']]: maxCount === 0,
        })}
        type={type || 'text'}
        placeholder={placeholder}
        value={value}
        disabled={isDisable}
        onChange={e => handleChange(e)}
        onFocus={() => {
          setIsFocus(true);
          onFocus();
        }}
        onBlur={() => {
          setIsFocus(false);
          onBlur();
        }}
      />
      {maxCount > 0 && (
        <span
          className={classnames(classes.wordCounter, {
            [classes['wordCounter--error']]:
              value.replace(filterName, '').length > maxCount,
          })}
        >
          {value.replace(filterName, '').length}/{maxCount}
        </span>
      )}
      {unit && <span className={classnames(classes.wordCounter)}>{unit}</span>}
    </div>
  );
}

TextFieldCardCounter.defaultProps = {
  className: undefined,
  maxCount: 20,
  placeholder: '',
  value: '',
  onChange: () => {},
  onFocus: () => {},
  status: 'default',
  inputRef: () => {},
  id: undefined,
  filterName: '',
  onBlur: () => {},
};

TextFieldCardCounter.propTypes = {
  className: PropTypes.string,
  maxCount: PropTypes.number,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  status: PropTypes.oneOf(['default', 'warning', 'error']),
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  id: PropTypes.string,
  filterName: PropTypes.any,
};

export default TextFieldCardCounter;
